import React, {ReactNode} from 'react'
import {UNIT_OF_BUSINESS_SCHEDULE} from '../../../../CodeMaster'
import SchedulesViewDetail from './SchedulesViewDetail'
import {TimeTableGroup, TimeTableItem} from './BusinessScheduleItemInterfaces'
import {compare} from './BusinessScheduleTimeHelper'
import equal from 'fast-deep-equal'

import { Tabs, Typography, Tab } from '@mui/material';

interface Props {
    items: TimeTableItem[]
    groupItems: TimeTableGroup[]
    onDeleteClick?: (id: string) => void
}

interface State {
    selectedTabValue: number
}

class SchedulesView extends React.Component<Props, State> {

    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            selectedTabValue: 0,
        }
        this.handleTabsChange = this.handleTabsChange.bind(this)
    }

    handleTabsChange(event: React.ChangeEvent<{}>, value: number): void {
        this.setState({selectedTabValue: value})
    }

    renderGroupTabPanelsNormal(): ReactNode {
        return <>{
            this.props.groupItems.map((group, index) => {
                const itemsInGroup =
                    [...this.props.items]
                        .sort((a, b) => compare(a.startTime, b.startTime))
                        .filter(item =>
                            item.businessScheduleUnit === group.businessScheduleUnit
                            || item.businessScheduleUnit === UNIT_OF_BUSINESS_SCHEDULE.ALL_DAYS)
                return (
                    <TabPanel key={index} visible={this.state.selectedTabValue === index}>
                        <SchedulesViewDetail
                            onDeleteClick={this.props.onDeleteClick}
                            items={itemsInGroup}
                            unitOfBusinessSchedule={group.businessScheduleUnit}
                        />
                    </TabPanel>
                )
            })
        }</>
    }

    renderGroupTabPanelsStraddle(): ReactNode {
        return (
            <TabPanel visible>
                <SchedulesViewDetail
                    onDeleteClick={this.props.onDeleteClick}
                    items={this.props.items.filter(
                        itemInGroup => itemInGroup.businessScheduleUnit === UNIT_OF_BUSINESS_SCHEDULE.DATE_STRADDLE,
                    )}
                    unitOfBusinessSchedule={UNIT_OF_BUSINESS_SCHEDULE.DATE_STRADDLE}
                />
            </TabPanel>
        )
    }

    render(): ReactNode {
        const {groupItems} = this.props

        const hasDateStraddle: boolean = groupItems.some(
            groupItem => groupItem.businessScheduleUnit === UNIT_OF_BUSINESS_SCHEDULE.DATE_STRADDLE,
        )

        return (
            <div>
                <GroupTabs
                    groupItems={groupItems}
                    selectedTabValue={this.state.selectedTabValue}
                    onChange={this.handleTabsChange}
                />
                {
                    (hasDateStraddle)
                        ? this.renderGroupTabPanelsStraddle()
                        : this.renderGroupTabPanelsNormal()
                }
            </div>
        )
    }
}

interface GroupTabsProps {
    groupItems: TimeTableGroup[]
    selectedTabValue: number
    onChange: (event: React.ChangeEvent<{}>, value: any) => void;
}

const GroupTabs: React.FC<GroupTabsProps> = React.memo(props => {
    return (
        <Tabs indicatorColor="primary" textColor="primary" variant="fullWidth" scrollButtons="auto"
              value={props.selectedTabValue}
              onChange={props.onChange}
        >
            {
                props.groupItems.map(group =>
                    <Tab style={{minWidth: 'auto', whiteSpace: 'nowrap'}}
                         key={group.businessScheduleUnit.value}
                         label={group.title}
                    />)
            }
        </Tabs>
    )
}, (prevProps, nextProps) => (prevProps === nextProps || equal(prevProps, nextProps)))
GroupTabs.displayName = 'GroupTabs'

const TabPanel: React.FC<{ visible: boolean, children?: ReactNode }> = props =>
    <Typography component="div" role="tabpanel" hidden={!props.visible}>{props.children}</Typography>
TabPanel.displayName = 'TabPanel'

export default SchedulesView
